import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const L2eRedemptionHistoryActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

L2eRedemptionHistoryActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

L2eRedemptionHistoryActions.defaultProps = {
  basePath: '',
  data: {},
};

export default L2eRedemptionHistoryActions;
